<app-banner [heading]="'TESTIMONIALS - PARENT\'S VIEW'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<section id="testimonials" >
  <div class="container">
    <div class="row justify-content-center">


<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Vihaan (UKG) </h4>
    <p>The teacher's expertise in teaching has put our minds at ease. We are so grateful to have her as our child's teacher.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-21</h2>
    <h4>Parents of Ashish (Grade X)</h4>
    <p>Everything here is fully satisfactory.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
<h4>Parents of Arshpreet (Grade VIII)</h4>			
  <p>I am very satisfied with the school.</p>
  
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Kanishka (Grade IX)</h4>

    <p>I am satisfied. My child is doing good.</p>
                  </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4> Parents of Mannat (Grade VIII)</h4>
    <p>Very satisfied </p>
                  </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Dikshant (Grade VII)</h4>
    <p>Very satisfied with the school. </p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Savyasachi (Grade VII)</h4>
    <p>Good efforts can be experienced by the staff.</p>

          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">

    <h2>30-09-2021</h2>
    <h4>Parents of Sakshi (Grade V)</h4>
    <p>Everything is great here.</p>

          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Rudrapratap (Grade IV)</h4>
    <p>All teachers are very good at TGS.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
            <h4> Parents of Uddish (Grade IV)</h4>
    <p>All is great here. Iam completely satisfied. </p>

          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Rudra Walia (Grade II)</h4>
    <p>Excellent performance in all subjects by my ward.All staff members are very cooperative and nice.They are doing very well.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-2021</h2>
    <h4>Parents of Rupika (Grade II)</h4>
          <p>Everything is perfect here.</p>
    
    </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2> 30-09-2021</h2>
    <h4>Parent of Shaila (Grade II)</h4>
    <p>Very satisfied </p>
     
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2> 30-09-2021</h2>
             <h4>Parent of Bhavika (Grade II) </h4>
    <p>Overall it is very nice here.My child is improving day by day.</p>
    

                </div>
 </div>
  <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>30-09-21 </h2>
    <h4>Parent of Harsirat (Grade I) </h4>
    <p>The teacher is very hard working and teaches in such a way that a child can understand easily. </p>
    </div>
</div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>17-08-2021</h2>
            <h4>Parent of Divyam ( Pre-Nursery) </h4>
            <p> Divyam is very fond of his class-teacher, the teachng method adopted by class incharge is easy and comprehensible.
    I wish all the very best to the school and thank them for inventing new ways of engaging kids for there holistic development. 
              
      
            </p>
          </div>
 </div> 
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>17-08-2021</h2>
            <h4> Parent of Aditya (Pre-Nursery)</h4>
            <p> Everything is great here. I am fully satisfied with the school and the teachers.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>16-08-2021</h2>
            <h4> Parent of Charvi ( Pre-nursery)</h4>
            <p> Classes are conducted very nicely here, Charvi has gained interest in studies only because of interactive session conducted by the class-teacher.<br>
     I would like to thank the teacher for her patience and  cooperation.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>16-08-2021</h2>
            <h4>Parent of Arav ( Pre- Nursery)</h4>
            <p> The class teacher is teaching in a superb way. She is very calm, polite and patient. She knows how to handle the students in a proper way . 
        Students also obey her. 
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Aadrika ( Pre-Nursery)</h4>
            <p> Online classes are being taken in a good manner and wards are enjoying it. 
    They are taking keen interest in the classes due to the effort of their teachers.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Amoha Goyal ( Pre-Nursery)</h4>
            <p> I am very happy to send my ward here. Amoha is making effort to do well.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Viraaj ( Pre- Nursery)</h4>
            <p>The teachers here are very cooperative. We are very satisfied.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Saera ( Pre- Nursery)</h4>
            <p> Everything is good here. Teachers are maintaining proper discipline amongst students which is appreciable. We are satisfied. 
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Gargi ( Pre-Nursery)</h4>
            <p> Good efforts are being made by school. 
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Rehana Narwal ( Pre-Nursery) </h4>
            <p> Teachers are making good efforts to improve children. Everything is good here.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Harjot  ( Pre-Nursery)</h4>
            <p> The school is very nice .
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Avira ( Nursery )</h4>
            <p> We are totally satisfied with the teaching. The Class teacher is very friendly and our kid is performing well.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Shaksham ( Nursery)</h4>
            <p> The class teacher is very good. 
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Hiral ( Nursery) </h4>
            <p> The class teacher is very cooperative . School Management is very good.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>parent of Yashaswni ( Nursery)</h4>
            <p>Class teacher's interaction level is excellent with students. 
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Pari ( Nursery)</h4>
            <p> The school is very good.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Divansh ( Nursery)</h4>
            <p> The school is very good .
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Mehreen ( Nursery)</h4>
            <p> The class teacher is very good. Her teaching method is good.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4>Parent of Arjun ( Nursery) </h4>
            <p> The Class teacher is very cooperative and labourious.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Harrin Kush ( Nursery )</h4>
            <p> Class taecher's online teaching method is so good, She always encourages our child to study and adopt good habbits.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Mohan ( Nursery)</h4>
            <p> Excellent mode of teaching, great atmosphere for studies, excellent teaching skill of the teacher.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Bhuvan ( Nursery)</h4>
            <p> Class teacher is very good and nice. The school is very good.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parent of Rehnoor ( Nursery)</h4>
            <p> The class teacher is really doing a good job.
              
      
            </p>
          </div>
 </div>
 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>07-08-2021</h2>
            <h4> Parents of Kavish ( Nursery)</h4>
            <p> The teacher's teaching method is very impressive. Everythng is understandable.
              
      
            </p>
          </div>
 </div> 

<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Vivaan Sharma (LKG)</h4>
    <p>  Online classes are going great.Teachers are very cooperative. </p>
    
                  </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
<h4> Parents of Manhar Singh (LKG) </h4>		
<p> Teachers are putting so much efforts. They are trying hard to interact with each student so that students take interest.</p>

           </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Gurahmat Singh (LKG)</h4>
    <p>All teachers of TGS are very supportive and cooperative. Students enjoy a lot here.</p>
    
          </div>
 </div>

<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Nariti (UKG)</h4>
    <p>Attitude of teachers is very positive. Way of teaching is very nice,teachers are well educated.Setup of classroom is good.
    Teacher's nature is very supportive. Studies are very good here. </p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Devanya (UKG)</h4>
    <p>The teacher is doing a very good job, her way of teaching is very impressive. </p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Simarjeev (UKG)</h4>
    <p>I am very  satisfied with the school.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Anaaya (UKG)</h4>
    <p>Teaching pattern is very good of the teacher.My child is very comfortable with her.</p>
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Lavish (UKG)</h4>
    <p>Online classes are going very well.The teacher handles all the children very smartly.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Aarush (UKG)</h4>
    <p>UKG class is going very well.The method of teaching is very nice.The teacher is very polite and sweet by nature.</p>
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Viraj (UKG)</h4>
    <p>It is great to have such nice Educators here.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Reyansh (UKG)</h4>
    <p>We are very satisfied with the Teacher's hard work. </p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Paridhi (UKG)</h4>
    <p>Everything is very good at TGS.Teacher's way of explaining is very good.Her behavior with children is too good.</p>

          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <p>Everything is good here. Online classes and teacher are also very good.</p>
    <h4>Parents of Nityam (UKG)</h4>
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Vinay (UKG)</h4>
    <p>We like this school very much. The school is very neat and clean.The teacher is also very good,she teaches very well. My child understands everything properly. 
Principal Mam is also very good. </p>
    
          </div>
 </div> 
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents of Bilal (UKG)</h4>
    <p>Online classes are being taken nicely covering the syllabus properly. 
    The class teacher is always motivating and encouraging in the class.</p>
    
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
    <h2>07-08-2021</h2>
    <h4>Parents  of Kritik (UKG)</h4>
    <p>I am very happy and satisfied  with the teaching method of the teacher.
    She is a humble and dedicated teacher who always puts child's education first.
    My child 's handwriting has improved and he is keen to know more now.
    Hope for some new exciting teacher- student learning experience in future.</p>
    
          </div>
 </div>	
    <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>26-04-2021</h2>
            <h4>Parent of Vannniya (LKG) </h4>
            <p> All parents are very happy with online evening classes.
              
      
            </p>
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>22-04-2021</h2>
            <h4>Parent of Tanishka (UKG)</h4>
            <p> We are very happy with online evening classes , We appreciate this effort made by the school for the working parents .
              
      
            </p>
          </div>
</div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>22-04-2021</h2>
            <h4> Parent of Kirat (UKG)</h4>
            <p> All is going very well, learning by the children is great here.
              
      
            </p>
          </div>
 </div>
<div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
              
      
            <h2>22-04-2021</h2>
            <h4> Parent of Kamaljot (Grade VI)</h4>
            <p>All is great here, syllabus is very good.
            </p>
          </div>
 </div>

 <div class="col-lg-6" id="testi">
          <div class="testimonial-item">
            <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
            <h2>22-04-2021</h2>
            <h4> Parent of Agamjot (Grade X)</h4>
            <p> We are very satisfied with this school.
              
      
            </p>
          </div>
 </div>
  
  </div>
</div></section>